<template>
  <a>
    <queueton-resource-status :resource="resource" :resource-id="resourceId">
      <template v-slot:default="slotProps">
        <span>
          Queueton Status: {{slotProps.status}}
        </span>
      </template>
    </queueton-resource-status>
  </a>
</template>

<script>

import QueuetonResourceStatus from "../queueton/QueuetonResourceStatus.vue";
export default {
  components: { QueuetonResourceStatus },
  props: {
    resource: {
      type: String,
      required: true,
    },
    resourceId: {
      type: [String, Number],
      required: true,
    }
  },
  name: "AdminQueuetonStatus"
}
</script>

